import { IAccount } from '../utils/interfaces/interfaces';

interface TypeUser {
  key: string;
  name: string;
}

const types_users = {
  admin: 'admin',
  secondary: 'secondary_user',
  principal: 'principal_user'
};

export enum Types {
  All = 'all',
  Legal = 'legal',
  Accounting = 'accounting'
}

const types_types = {
  all: 'all',
  legal: 'legal',
  accounting: 'accounting'
};

export const AllTypes = [
  { key: Types.All, name: 'Litigii si Rapoarte de control' },
  { key: Types.Legal, name: 'Litigii' },
  { key: Types.Accounting, name: 'Rapoarte de control' }
];

export type TypeDropdown = {
  key: Types;
  name: string;
};

const users_status = {
  active: 'active',
  disabled: 'disabled'
};

export { types_users, users_status, types_types };
export type { TypeUser };

export type User = IAccount;

export type LoginRequest = Pick<User, 'email' | 'password'>;
export type ChangePasswordRequest = {
  newPassword: string;
  confirmNewPassword: string;
};

export type ResetPasswordRequest = {
  newPassword: string;
  confirmNewPassword: string;
  token: string;
};

export enum Roles {
  PrincipalUser = 'principal_user'
}
